<div class="improve-audio-dialog">
  <h2 mat-dialog-title>
    {{ 'pages.improve-audio.dialog.header' | transloco }}
  </h2>

  <mat-dialog-content>
    <p class="intro-text">
      {{ 'pages.improve-audio.dialog.body' | transloco }}
    </p>

    <div class="tips-container">
      <mat-accordion>
        <mat-expansion-panel expanded>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon class="large-icon">wifi</mat-icon>
              {{ 'pages.improve-audio.dialog.internet.title' | transloco }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p>
            <strong>{{ 'pages.improve-audio.dialog.tip' | transloco }}</strong>
            {{ 'pages.improve-audio.dialog.internet.description' | transloco }}
          </p>

          <div class="speedtest-container">
            @if (isSpeedtestRunning()) {
              <div class="speedtest-progress">
                <p class="speedtest-status">{{ 'pages.improve-audio.dialog.speedtest.running' | transloco }}</p>
                <p class="speedtest-wait">{{ 'pages.improve-audio.dialog.speedtest.wait' | transloco }}</p>
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
              </div>
            } @else {
              @if (speedtestResults.error) {
                <div class="speedtest-error">
                  <p>{{ speedtestResults.error }}</p>
                </div>
              } @else if (speedtestResults.upload) {
                <div class="speedtest-success">
                  <div class="network-assessment">
                    <p>
                      <mat-icon
                        [color]="
                          speedtestResults.upload >= uploadSpeedThreshold &&
                          speedtestResults.latency < uploadSpeedThreshold
                            ? 'success'
                            : 'warn'
                        ">
                        {{
                          speedtestResults.upload >= uploadSpeedThreshold &&
                          speedtestResults.latency < uploadSpeedThreshold
                            ? 'check_circle'
                            : 'warning'
                        }}
                      </mat-icon>
                      {{
                        speedtestResults.upload >= uploadSpeedThreshold &&
                        speedtestResults.latency < uploadSpeedThreshold
                          ? ('pages.improve-audio.dialog.speedtest.sufficient' | transloco)
                          : ('pages.improve-audio.dialog.speedtest.insufficient' | transloco)
                      }}
                    </p>
                  </div>
                </div>
              }
            }
          </div>

          <mat-action-row>
            <button
              mat-button
              color="primary"
              aria-label="Check internet connection"
              [disabled]="isSpeedtestRunning()"
              (click)="runSpeedtest()">
              @if (!speedtestResults.upload && !speedtestResults.error) {
                {{ 'pages.improve-audio.dialog.internet.button' | transloco }}
              } @else {
                {{ 'pages.improve-audio.dialog.internet.button_retry' | transloco }}
              }
            </button>
          </mat-action-row>
        </mat-expansion-panel>

        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon class="large-icon">bluetooth</mat-icon>
              {{
                'pages.improve-audio.dialog.connection.title' | transloco
              }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p>
            <strong>Tip:</strong>
            {{
              'pages.improve-audio.dialog.connection.description'
                | transloco
            }}
          </p>
        </mat-expansion-panel>

        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon class="large-icon">mic</mat-icon>
              {{
                'pages.improve-audio.dialog.microphone-kit.title' | transloco
              }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p>
            <strong>Tip:</strong>
            {{
              'pages.improve-audio.dialog.microphone-kit.description'
                | transloco
            }}
          </p>
          <!-- Hide this button until iOS is fully rolled out with new version -->
          <mat-action-row>
            <button
              mat-button
              color="primary"
              aria-label="View microphone instructions"
              (click)="openMicrophoneGuide()">
              {{
                'pages.improve-audio.dialog.microphone-kit.button' | transloco
              }}
            </button>
          </mat-action-row>
        </mat-expansion-panel>

        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon class="large-icon">language</mat-icon>
              {{ 'pages.improve-audio.dialog.language.title' | transloco }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p>
            <strong>Tip:</strong>
            {{ 'pages.improve-audio.dialog.language.description' | transloco }}
          </p>
          <mat-action-row>
            <button
              mat-button
              color="primary"
              aria-label="Change language settings"
              (click)="openLanguageDialog()">
              {{ 'pages.improve-audio.dialog.language.button' | transloco }}
            </button>
          </mat-action-row>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close class="large-button">
      {{ 'pages.improve-audio.dialog.close' | transloco }}
    </button>
  </mat-dialog-actions>
</div>
